module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('router-link', {
    staticClass: "footer__link",
    attrs: {
      "to": {
        name: 'pfdod-info'
      }
    }
  }, [_vm._v("Подробнее о сертфикатах и их получении")]), (_vm.actionText) ? _c('Button', {
    staticClass: "footer__action",
    on: {
      "click": function($event) {
        return _vm.$emit('action')
      }
    }
  }, [_vm._v(_vm._s(_vm.actionText))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14704847","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/footer/Footer.vue
// module id = 327aa1309ab81ef5603a
// module chunks = 9